(function () { if (!LN.Config) throw new Error("LN.Config missing"); })();

(function (Config, Constantes) {
    'use strict';

    Config.defaultModo = 'D';
    Config.urlViews = window.location.origin + '/views/login/';

    Config.defaultUrl = window.location.origin + '/ingresar/' + Config.defaultModo + '/' + Config.defaultSitioId + '/';

    Config.ingresarPrefix = /ingresar/;
    Config.cambiarClavePrefix = /clave/;

    Config.HotjarHeatmapLogin = Constantes.HotjarHeatmapLogin;

    Config.smartLockEnabled = Constantes.smartLockEnabled;
    Config.smartlockPasswordEnable = Constantes.smartlockPasswordEnable;
    // ==================================================
    // Modos permitidos
    // modo (char) = (D) - default / (S) - signwall / (B) - black / (P) - paywall / (C) - cambiar PASSWORD / (V) - VALIDAR CREDENCIAL / (A) - Asignar credencial / (CLA) - Club LN vincular credencial
    // ==================================================      
    Config.Modos = ['D', 'S', 'B', 'P', 'C', 'AT', 'V', 'A', 'GLA', 'CLA'];

    // ==================================================
    // Constantes de backgrounds
    // ==================================================  
    Config.Background = {
        'D': {
            'file': 'default',
            'class': 'info-signwall',
        },
        'C': {
            'file': 'default',
            'class': 'info-signwall',
        },
        'S': {
            'file': 'signwall',
            'class': 'info-signwall',
        },
        'B': {
            'file': 'black',
            'class': 'fondo-black',
        },
        'V': {
            'file': 'black',
            'class': 'fondo-black'
        },
        'P': {
            'file': 'paywall',
            'class': 'info-signwall'
        },
        'A': {
            'file': 'default',
            'class': 'info-signwall'
        },
        'GLA': {
            'file': 'default',
            'class': 'info-signwall'
      },
      'CLA': {
        'file': 'default',
        'class': 'info-signwall'
      }
    };

    Config.Header = {
        'D': {
            'file': 'default',
            'class': 'info-signwall',
        },
        'C': {
            'file': 'default',
            'class': 'info-signwall',
        },
        'S': {
            'file': 'signwall',
            'class': 'info-signwall',
        },
        'B': {
            'file': 'black',
            'class': 'fondo-black',
        },
        'V': {
            'file': 'black',
            'class': 'fondo-black'
        },
        'P': {
            'file': 'paywall',
            'class': 'info-signwall'
        },
        'A': {
            'file': 'default',
            'class': 'info-signwall'
        },
        'GLA': {
            'file': 'default',
            'class': 'info-signwall'
      },
      'CLA': {
        'file': 'default',
        'class': 'info-signwall'
      }
    };

    Config.Titles = {
        'D': {
            'file': 'default'
        },
        'C': {
            'file': 'default',
            'class': 'info-signwall'
        },
        'S': {
            'file': 'signwall'
        },
        'B': {
            'file': 'black'
        },
        'V': {
            'file': 'black'
        },
        'P': {
            'file': 'default'
        },
        'A': {
            'file': 'default'
        },
        'GLA': {
            'file': 'default'
      },
      'CLA': {
        'file': 'default'
      }
    };

    // ==================================================
    // Constantes de steps o pasos
    // ==================================================  
    Config.Step = {
        COOKIES_DESHABILITADAS: {
            file: 'cookies_deshabilitadas',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: []
        },
        INICIO: {
            file: 'inicio',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: [],
        },
        ACCEDER_NATIVO_INGRESAR_PASSWORD: {
            file: 'acceder_nativo_ingresar_password',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['inicio', 'acceder_nativo_ingresar_password'],
        },
        CREAR_CUENTA_NATIVO: {
            file: 'crear_cuenta_nativo',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['crear_cuenta_gracias'],
        },
        CREAR_CUENTA_DIRECTO: {
            file: 'crear_cuenta_directo_unica',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['inicio', 'crear_cuenta_datos', 'crear_cuenta_directo_unica', 'acceder_red_social', 'facilitar_acceso_google'],
        },
        CREAR_CUENTA_DATOS: {
            file: 'crear_cuenta_datos',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['crear_cuenta_gracias'],
        },
        CREAR_CUENTA_PASSWORD: {
            file: 'crear_cuenta_password',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['crear_cuenta_gracias'],
        },
        CREAR_CUENTA_VALIDAR_CODIGO: {
            file: 'crear_cuenta_validar_codigo',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['crear_cuenta_directo_unica','crear_cuenta_password', 'acceder_nativo_ingresar_password', 'crear_cuenta_red_social', 'crear_cuenta_validar_codigo', 'inicio'],
        },
        CREAR_CUENTA_GRACIAS: {
            file: 'crear_cuenta_gracias',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['crear_cuenta_validar_codigo'],
        },
        CREAR_CUENTA_RED_SOCIAL: {
            file: 'crear_cuenta_red_social',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['inicio', 'acceder_nativo_caso_1'],
        },
        VINCULAR_TARJETA: {
            file: 'vincular_tarjeta',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: [],
        },
        ACCEDER_NATIVO_CASO_1: {
            file: 'acceder_nativo_caso_1',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['acceder_nativo_ingresar_password'],
        },
        ACCEDER_NATIVO_CASO_2: {
            file: 'acceder_nativo_caso_2',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['acceder_nativo_ingresar_password'],
        },
        ACCEDER_RED_SOCIAL: {
            file: 'acceder_red_social',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['inicio'],
        },
        REESTABLECER_PASSWORD: {
            file: 'reestablecer_password',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['inicio', 'acceder_nativo_ingresar_password', 'crear_cuenta_gracias'],
        },
        REESTABLECER_PASSWORD_CODIGO: {
            file: 'reestablecer_password_codigo',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: [],
        },
        REESTABLECER_PASSWORD_CODIGO_GRACIAS: {
            file: 'reestablecer_password_codigo_gracias',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: [],
        },
        REESTABLECER_PASSWORD_EXPIRADO: {
            file: 'reestablecer_password_expirado',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['acceder_nativo_caso_1'],
        },
        MOSTRAR_ERROR: {
            file: 'mostrar_error',
            title: 'Error',
            flow: [],
        },
        ASOCIAR_TARJETA_NO_BLACK: {
            file: 'asociar_tarjeta_no_black',
            title: 'Tarjeta no válida',
            flow: []
        },
        ASOCIAR_TARJETA: {
            file: 'asociar_tarjeta',
            title: 'Asociar Tarjeta',
            flow: []
        },
        REESTABLECER_PASSWORD_ENVIO: {
            file: 'reestablecer_password_envio',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['reestablecer_password'],
        },
        FACILITAR_ACCESO_GOOGLE: {
            file: 'facilitar_acceso_google',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['inicio', 'crear_cuenta_directo_unica']
        }
    };

  


})(LN.Config, window.config.Constantes);





// WEBPACK FOOTER //
// ./Statics/scripts/login/core/config.js